export default __webpack_public_path__ + "static/media/banner-contact.edadd1e8.webp";